export default __webpack_public_path__ + "static/media/easywebinar_logo.6524beab.png";